import React, { useState } from "react";
import {
  Box,
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useSurveyStatus } from "../../dashboard/hooks/useSurveyStatus";
import { SurveyRunner } from "./SurveyRunner";

export function PaywallSurveyOffer({
  feature,
  isOpen,
  onClose,
  onUnlock,
  onSubscribe,
  onDismiss,
}) {
  const { t } = useTranslation("common");
  const { status } = useSurveyStatus();
  const [showingSurvey, setShowingSurvey] = useState(false);

  const nextSurvey = status?.available_surveys?.find((s) => s.kind === "module")
    || status?.available_surveys?.[0];

  const handleSurveyComplete = (unlockInfo) => {
    setShowingSurvey(false);
    if (onUnlock) onUnlock(unlockInfo);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent borderRadius="xl" overflow="hidden">
        <ModalCloseButton />
        <ModalBody py={8} px={6}>
          {showingSurvey && nextSurvey ? (
            <SurveyRunner
              code={nextSurvey.code}
              sourceContext="paywall"
              metadata={{ unlock_feature: feature }}
              onComplete={handleSurveyComplete}
              onAbandon={() => setShowingSurvey(false)}
            />
          ) : (
            <VStack spacing={6} textAlign="center">
              <Heading size="md" color="gray.800">
                {t("paywall.title", "Premium feature")}
              </Heading>
              <Text color="gray.600" fontSize="sm">
                {t("paywall.subtitle", "Choose how you'd like to continue:")}
              </Text>

              <VStack spacing={3} w="100%">
                <Button
                  colorScheme="gwbi"
                  size="lg"
                  w="100%"
                  onClick={() => { if (onSubscribe) onSubscribe(); }}
                >
                  {t("paywall.subscribe", "Subscribe")}
                </Button>

                {nextSurvey && (
                  <Button
                    variant="outline"
                    colorScheme="gwbi"
                    size="lg"
                    w="100%"
                    onClick={() => setShowingSurvey(true)}
                  >
                    {t("paywall.take_survey", "Take a {{min}}-min survey", {
                      min: nextSurvey.estimated_minutes || 10,
                    })}
                  </Button>
                )}

                <Button
                  variant="ghost"
                  color="gray.500"
                  size="sm"
                  onClick={() => { if (onDismiss) onDismiss(); onClose(); }}
                >
                  {t("paywall.continue_limited", "Continue with limits")}
                </Button>
              </VStack>

              <Box bg="gray.50" p={3} borderRadius="md" w="100%">
                <Text fontSize="xs" color="gray.500" textAlign="center">
                  {t("paywall.disclaimer",
                    "Survey responses contribute to published academic research on the global wine industry. All data is anonymized and aggregated."
                  )}
                </Text>
              </Box>
            </VStack>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
